// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"e615caa4","178":"1b8db79f","218":"d860d808","233":"9c2d2fe6","519":"b1dfb77c","682":"e50c94e2","734":"ffcfcb2d","942":"fdfa9b88"}[chunkId] + ".chunk.js";
};